import EventsSerializer from './base';

export default class CostMapping extends EventsSerializer {}
